// frontend/src/pages/reports/DailyProgressReport.js
import React, { useEffect, useState } from 'react';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, Typography, TextField } from '@mui/material';
import ReportTemplate from '../../components/reports/ReportTemplate';
import { getDailyProgressReport } from '../../services/reportService';

const DailyProgressReport = () => {
  const [data, setData]         = useState(null);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState('');
  const today = new Date().toISOString().split('T')[0];
  const thirtyDaysAgo = new Date(Date.now() - 30*24*60*60*1000).toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(thirtyDaysAgo);
  const [endDate, setEndDate]     = useState(today);

  const load = async () => {
    setLoading(true); setError('');
    try { const res = await getDailyProgressReport(startDate, endDate); setData(res.data.data); }
    catch (err) { setError(err.response?.data?.message || 'Failed to load report'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const dailyData = data?.dailyData || [];
  const summary   = data?.summary;
  const exercise  = data?.exercise;

  const exportCols = [
    { key: 'date', label: 'Date' }, { key: 'totalVerified', label: 'Total Verified' },
    { key: 'topZone', label: 'Top Zone' }, { key: 'topOfficer', label: 'Top Officer' },
  ];

  const summaryItems = summary ? [
    { label: 'Total Days',      value: summary.totalDays,                       color: 'primary.main', bg: '#e3f2fd' },
    { label: 'Total Verified',  value: summary.totalVerified?.toLocaleString(), color: 'success.main', bg: '#e8f5e9' },
    { label: 'Average Per Day', value: summary.averagePerDay,                   color: 'info.main',    bg: '#e0f7fa' },
    { label: 'Best Day Count',  value: summary.highestDay?.totalVerified || 0,  color: 'warning.main', bg: '#fff3e0' },
  ] : [];

  return (
    <ReportTemplate title="Daily Progress Report" subtitle={exercise ? `${exercise.name} — ${exercise.year}` : ''}
      loading={loading} error={error} onRefresh={load}
      exportFileName="Daily_Progress_Report" exportData={dailyData} exportColumns={exportCols}
      summaryItems={summaryItems}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Box display="flex" gap={2} mb={3} flexWrap="wrap" alignItems="center">
          <TextField size="small" label="Start Date" type="date" value={startDate}
            onChange={(e) => setStartDate(e.target.value)} InputLabelProps={{ shrink: true }} />
          <TextField size="small" label="End Date" type="date" value={endDate}
            onChange={(e) => setEndDate(e.target.value)} InputLabelProps={{ shrink: true }} />
          <Box component="span" onClick={load}
            sx={{ px: 2, py: 1, bgcolor:'primary.main', color:'white', borderRadius:1, cursor:'pointer', fontSize:'0.875rem', fontWeight:'bold', '&:hover':{bgcolor:'primary.dark'} }}>
            Apply
          </Box>
        </Box>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: 'grey.100' }}>
              <TableCell><strong>Date</strong></TableCell>
              <TableCell align="right"><strong>Total Verified</strong></TableCell>
              <TableCell><strong>Top Zone</strong></TableCell>
              <TableCell><strong>Top Officer</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dailyData.map((d) => (
              <TableRow key={d.date} hover>
                <TableCell><Typography variant="body2" fontWeight="bold">{d.date}</Typography></TableCell>
                <TableCell align="right" sx={{ color:'success.main', fontWeight:'bold', fontSize:'1rem' }}>{d.totalVerified}</TableCell>
                <TableCell><Typography variant="caption">{d.topZone}</Typography></TableCell>
                <TableCell><Typography variant="caption">{d.topOfficer}</Typography></TableCell>
              </TableRow>
            ))}
            {dailyData.length === 0 && <TableRow><TableCell colSpan={4} align="center" sx={{py:4,color:'text.secondary'}}>No data for selected date range</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Paper>
    </ReportTemplate>
  );
};
export default DailyProgressReport;